import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface SignUpWelcomeMessage {
  present: boolean
  title: string
  description: string
}

const initialState: SignUpWelcomeMessage = {
  present: false,
  title: '',
  description: '',
}

export const signUpWelcomeSlice = createSlice({
  name: 'signUpWelcome',
  initialState,
  reducers: {
    setWelcomeMessage: (state, action: PayloadAction<SignUpWelcomeMessage>) => {
      state.present = true
      state.title = action.payload.title
      state.description = action.payload.description
    },
    clearWelcomeMessage: (state) => {
      state.present = false
      state.title = ''
      state.description = ''
    },
  },
})

export const { setWelcomeMessage, clearWelcomeMessage } =
  signUpWelcomeSlice.actions

export default signUpWelcomeSlice.reducer
